import React from 'reactn';
import { useQuery } from 'react-apollo-hooks';
import gql from 'graphql-tag';
import get from 'lodash/get';
import subWeeks from 'date-fns/subWeeks';
import addWeeks from 'date-fns/addWeeks';
import format from 'date-fns/format';

const WEEK_RANGE = 8;

export const periodRangeQuery = gql`
  query($startDate: String, $endDate: String) {
    list: periodByType(
      limit: 999
      type: WEEK
      dateFrom: { between: [$startDate, $endDate] }
    ) {
      nextToken
      items {
        id
        name
        dateFrom
        dateTo
        type
        description
        wab {
          filename
        }
        brainBank {
          filename
        }
      }
    }
  }
`;

export default function usePeriodByDateRange({
  fromDate,
  range = WEEK_RANGE,
  startDate,
  endDate
} = {}) {
  // const [state, setState] = React.useState({ result: undefined, periods: [] });

  // const { getModelSchema } = React.useContext(AmplifyModelContext);

  const pQueryVars = React.useMemo(() => {
    console.log('kraken calleed again', startDate, endDate);
    let start, end;
    if (startDate instanceof Date) {
      start = startDate;
    }
    if (endDate instanceof Date) {
      end = endDate;
    }

    if (!start || !end) {
      const midPoint = fromDate || new Date();
      const rad = Math.floor(range / 2);
      start = subWeeks(midPoint, rad);
      end = addWeeks(midPoint, rad);
    }

    return {
      endDate: format(end, 'yyyy-MM-dd'),
      startDate: format(start, 'yyyy-MM-dd')
    };
  }, [fromDate, startDate, endDate, range]);

  const { data: periodList, loading } = useQuery(periodRangeQuery, {
    variables: pQueryVars,
    fetchPolicy: 'network-only'
  });

  const periodListSorted = React.useMemo(() => {
    return get(periodList, 'list.items', []).sort((a, b) =>
      a.dateTo > b.dateTo ? -1 : 1
    );
  }, [periodList]);

  return {
    periodList: periodListSorted,
    loading,
    weekRange: pQueryVars
  };
}
